import MobileDepartingDirection from './commons/DepartingDirection/Mobile';
import MobileBookReturnTrip from './commons/BookReturnTrip/Mobile';
import builder from './builder.js';

export default builder({
  DepartingComponent: MobileDepartingDirection,
  ReturningComponent: MobileBookReturnTrip
});
